package diana.soleil.design.iraniancanadienbazzar.feature.business

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.common.Validators
import diana.soleil.design.iraniancanadienbazzar.core.model.ClaimRole
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_error
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_retry
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_business_header
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_error_email
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_error_phone
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_error_required
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_email_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_email_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_intro
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_message_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_message_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_name_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_name_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_phone_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_phone_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_proof_attach
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_proof_attached
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_proof_hint
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_proof_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_role_employee
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_role_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_role_manager
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_role_other
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_role_owner
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_screen_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_submit
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_submit_failed
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_success_desc
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_success_done
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.claim_success_title
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

/**
 * Stateful entry for the claim flow: resolves [ClaimBusinessViewModel] (scoped to [businessId]) and
 * drives the submit lifecycle. [onSubmitted] fires when the claimant taps Done on the success panel;
 * [onRequireSignIn] routes guests to sign-in (auth is wired by the host). Self-contained — the shell
 * supplies the nav callbacks; this composable owns no navigation.
 */
@Composable
fun ClaimBusinessRoute(
    businessId: String,
    onBack: () -> Unit,
    onSubmitted: () -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ClaimBusinessViewModel = koinViewModel(parameters = { parametersOf(businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    LaunchedEffect(state.submitStatus) {
        if (state.submitStatus == ClaimSubmitStatus.SignInRequired) {
            viewModel.consumeSubmitStatus()
            onRequireSignIn()
        }
    }
    ClaimBusinessScreen(
        state = state,
        onBack = onBack,
        onSubmit = viewModel::submit,
        onAttachProof = viewModel::attachProof,
        onRemoveProof = viewModel::removeProof,
        onRetry = viewModel::retry,
        onDone = onSubmitted,
        modifier = modifier,
    )
}

/** One selectable role chip: the [ClaimRole] it maps to + its localized label. */
private data class RoleOption(val role: ClaimRole, val label: StringResource)

private val ROLE_OPTIONS = listOf(
    RoleOption(ClaimRole.Owner, Res.string.claim_role_owner),
    RoleOption(ClaimRole.Manager, Res.string.claim_role_manager),
    RoleOption(ClaimRole.Employee, Res.string.claim_role_employee),
    RoleOption(ClaimRole.Other, Res.string.claim_role_other),
)

/**
 * Claim Business — a verification form submitted for admin approval. Tokens + string resources only.
 * Stateless; the editable fields are local state, results come in via [ClaimBusinessUiState].
 */
@Composable
fun ClaimBusinessScreen(
    state: ClaimBusinessUiState,
    onBack: () -> Unit,
    onSubmit: (ClaimSubmission) -> Unit,
    onAttachProof: () -> Unit,
    onRemoveProof: () -> Unit,
    onRetry: () -> Unit,
    onDone: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(modifier = modifier.fillMaxSize().background(AppTheme.colors.background)) {
        // Teal top bar (matches Write a Review / the wizard chrome).
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.primaryContainer)
                .statusBarsPadding()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.claim_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onPrimary,
            )
            Text(
                text = stringResource(Res.string.claim_screen_title),
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onPrimary,
            )
        }

        when {
            state.loading -> LoadingState()
            state.error -> ErrorState(
                message = stringResource(Res.string.business_error),
                onRetry = onRetry,
                retryLabel = stringResource(Res.string.business_retry),
            )
            state.submitStatus == ClaimSubmitStatus.Submitted -> ClaimSuccess(onDone = onDone)
            else -> ClaimForm(
                state = state,
                submitting = state.submitting,
                failed = state.submitStatus == ClaimSubmitStatus.Failed,
                onSubmit = onSubmit,
                onAttachProof = onAttachProof,
                onRemoveProof = onRemoveProof,
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ClaimForm(
    state: ClaimBusinessUiState,
    submitting: Boolean,
    failed: Boolean,
    onSubmit: (ClaimSubmission) -> Unit,
    onAttachProof: () -> Unit,
    onRemoveProof: () -> Unit,
) {
    var name by remember(state.prefillName) { mutableStateOf(state.prefillName) }
    var role by remember { mutableStateOf(ClaimRole.Owner) }
    var email by remember { mutableStateOf("") }
    var phone by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }
    // Inline validation: Submit stays tappable; an invalid tap lights up the missing fields instead
    // of leaving a silently-disabled button the claimant can't diagnose (owner bug 2026-07-27).
    var showErrors by remember { mutableStateOf(false) }

    val nameError = showErrors && name.isBlank()
    val emailError = showErrors && !email.isValidEmail()
    val messageError = showErrors && message.isBlank()
    // Phone is optional, so only invalid when the user typed something that isn't a plausible number.
    val phoneError = phone.isNotBlank() && !Validators.isValidPhone(phone)
    val valid = name.isNotBlank() && email.isValidEmail() && message.isNotBlank() &&
        (phone.isBlank() || Validators.isValidPhone(phone))

    Column(
        modifier = Modifier
            .fillMaxHeight()
            .appContentWidth(AppTheme.sizes.contentMaxWidthCompact)
            .verticalScroll(rememberScrollState())
            .navigationBarsPadding()
            .padding(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
    ) {
        Card {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs)) {
                Text(
                    text = stringResource(Res.string.claim_business_header, state.businessName),
                    style = AppTheme.typography.headlineMd,
                    color = AppTheme.colors.onSurface,
                )
                Text(
                    text = stringResource(Res.string.claim_intro),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }

        // Role
        FieldLabel(stringResource(Res.string.claim_role_label))
        FlowRow(
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            ROLE_OPTIONS.forEach { option ->
                AppChip(
                    label = stringResource(option.label),
                    selected = option.role == role,
                    onClick = { role = option.role },
                )
            }
        }

        // Name
        FieldLabel(stringResource(Res.string.claim_name_label))
        AppTextField(
            value = name,
            onValueChange = { name = it },
            placeholder = stringResource(Res.string.claim_name_placeholder),
            isError = nameError,
            supportingText = stringResource(Res.string.claim_error_required).takeIf { nameError },
            modifier = Modifier.fillMaxWidth(),
        )

        // Email
        FieldLabel(stringResource(Res.string.claim_email_label))
        AppTextField(
            value = email,
            onValueChange = { email = it },
            placeholder = stringResource(Res.string.claim_email_placeholder),
            isError = emailError,
            supportingText = stringResource(Res.string.claim_error_email).takeIf { emailError },
            modifier = Modifier.fillMaxWidth(),
        )

        // Phone (optional)
        FieldLabel(stringResource(Res.string.claim_phone_label))
        AppTextField(
            value = phone,
            onValueChange = { phone = it },
            placeholder = stringResource(Res.string.claim_phone_placeholder),
            keyboardType = androidx.compose.ui.text.input.KeyboardType.Phone,
            isError = phoneError,
            supportingText = stringResource(Res.string.claim_error_phone).takeIf { phoneError },
            modifier = Modifier.fillMaxWidth(),
        )

        // Verification message
        FieldLabel(stringResource(Res.string.claim_message_label))
        AppTextField(
            value = message,
            onValueChange = { message = it },
            placeholder = stringResource(Res.string.claim_message_placeholder),
            singleLine = false,
            isError = messageError,
            supportingText = stringResource(Res.string.claim_error_required).takeIf { messageError },
            modifier = Modifier.fillMaxWidth().heightIn(min = AppTheme.sizes.reviewCommentMinHeight),
        )

        // Proof (optional) — a photo of a licence/bill/storefront, uploaded privately with the claim.
        FieldLabel(stringResource(Res.string.claim_proof_label))
        if (state.proofAttached) {
            AppChip(
                label = stringResource(Res.string.claim_proof_attached),
                selected = true,
                leadingIcon = "close",
                onClick = onRemoveProof,
            )
        } else {
            AppButton(
                text = stringResource(Res.string.claim_proof_attach),
                onClick = onAttachProof,
                variant = AppButtonVariant.Secondary,
                leadingIcon = "add_photo_alternate",
                modifier = Modifier.fillMaxWidth(),
            )
        }
        Text(
            text = stringResource(Res.string.claim_proof_hint),
            style = AppTheme.typography.bodySm,
            color = AppTheme.colors.onSurfaceVariant,
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.card)
                .padding(AppTheme.spacing.md),
        )

        if (failed) {
            Text(
                text = stringResource(Res.string.claim_submit_failed),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onErrorContainer,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .background(AppTheme.colors.errorContainer, AppTheme.shapes.card)
                    .padding(AppTheme.spacing.md),
            )
        }

        AppButton(
            text = stringResource(Res.string.claim_submit),
            onClick = {
                if (!valid) {
                    showErrors = true
                } else {
                    onSubmit(
                        ClaimSubmission(
                            claimantName = name.trim(),
                            role = role,
                            contactEmail = email.trim(),
                            contactPhone = phone.trim(),
                            message = message.trim(),
                        ),
                    )
                }
            },
            modifier = Modifier.fillMaxWidth(),
            trailingIcon = "send",
            enabled = !submitting,
            loading = submitting,
        )
    }
}

@Composable
private fun ClaimSuccess(onDone: () -> Unit) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(AppTheme.spacing.xl),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg, Alignment.CenterVertically),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppIcon(
            name = "check_circle",
            tint = AppTheme.colors.primary,
            size = AppTheme.sizes.iconHero,
        )
        Text(
            text = stringResource(Res.string.claim_success_title),
            style = AppTheme.typography.headlineMd,
            color = AppTheme.colors.onSurface,
            textAlign = TextAlign.Center,
        )
        Text(
            text = stringResource(Res.string.claim_success_desc),
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurfaceVariant,
            textAlign = TextAlign.Center,
        )
        AppButton(
            text = stringResource(Res.string.claim_success_done),
            onClick = onDone,
            modifier = Modifier.fillMaxWidth(),
            leadingIcon = "check",
        )
    }
}

@Composable
private fun Card(content: @Composable () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(AppTheme.colors.surface, AppTheme.shapes.card)
            .padding(AppTheme.spacing.lg),
    ) { content() }
}

@Composable
private fun FieldLabel(text: String) {
    Text(text = text, style = AppTheme.typography.labelMd, color = AppTheme.colors.onSurfaceVariant)
}

/** Minimal email sanity check for enabling submit (server/rules do the real validation). */
private fun String.isValidEmail(): Boolean {
    val at = indexOf('@')
    val dot = lastIndexOf('.')
    return at > 0 && dot > at + 1 && dot < length - 1
}
